/** @format */

import React, { useCallback } from 'react';
import languageBtn from '../../../../images/img/language.svg';
import { useHistory } from 'react-router-dom';
import i18n from 'i18next';
import { LanguageWrapper } from '../styles';

const Language = () => {
	const history = useHistory();
	const setActiveTab = useCallback((e) => {
		e.preventDefault();
		const lngValue = e.target.innerText;
		const pathname = window.location.pathname.split('/').slice(2).join('/');
		if (lngValue === 'English') {
			history.push(`/en/${pathname}`);
			i18n.changeLanguage('en');
		}

		if (lngValue === '中文') {
			history.push(`/zh-tw/${pathname}`);
			i18n.changeLanguage('zh-TW');
		}
	}, []);

	return (
		<LanguageWrapper>
			<div className="dropdown is-hoverable">
				<div className="dropdown-trigger">
					<button className="button is-white is-text">
						<span className="icon is-medium">
							<img src={languageBtn} alt="" />
						</span>
					</button>
				</div>
				<div className="dropdown-menu " id="dropdown-menu" role="menu">
					<div className="dropdown-content">
						<a href="#" className="dropdown-item" onClick={setActiveTab}>
							中文
						</a>
						<a href="#" className="dropdown-item" onClick={setActiveTab}>
							English
						</a>
					</div>
				</div>
			</div>
		</LanguageWrapper>
	);
};

export default React.memo(Language);
